import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { RadioInput } from '../models/radio-input';

@Component({
    selector: 'lib-radios',
    templateUrl: './radios.component.html',
    styleUrls: ['./radios.component.scss'],
    standalone: false
})
export class RadiosComponent {

  @Input() radioInputs: RadioInput[]
  @Input() block: boolean = false;
  @Input() defaultChecked?: string;
  @Input() formControlProperty: UntypedFormControl = new UntypedFormControl(this.defaultChecked);
  @Input() titleDisplay: 'block' | 'inline' = 'block';
  @Input() groupDirection: 'column' | 'row' = 'column';
  @Input() error?: string;

  @Output() selectedOption = new EventEmitter<RadioInput>();

  selectOption(option: RadioInput): void {
    this.selectedOption.emit(option);
  }

}
